import { Alert } from "@mui/material";
import React from "react";

type ReactComponentErrorBoundaryProps = React.PropsWithChildren<{
  resetKey: string;
  componentName: string;
}>;

type ReactComponentErrorBoundaryState = { error?: Error };

export default class ReactComponentErrorBoundary extends React.Component<ReactComponentErrorBoundaryProps, ReactComponentErrorBoundaryState> {
  public state: ReactComponentErrorBoundaryState = {};

  public static getDerivedStateFromError(error: Error): ReactComponentErrorBoundaryState {
    return { error };
  }

  public componentDidUpdate(previousProps: ReactComponentErrorBoundaryProps): void {
    if (this.state.error && previousProps.resetKey !== this.props.resetKey) {
      this.setState({ error: undefined });
    }
  }

  public render(): React.ReactNode {
    if (this.state.error) {
      return (
        <Alert severity="error">
          React component '{this.props.componentName}' failed: {this.state.error.message}
        </Alert>
      );
    }

    return this.props.children;
  }
}
